import FormKyc from './FormKyc/FormKyc'

export const FormKycPage = FormKyc;